module.exports = __webpack_public_path__ + "img/lbl-01.23238f4e.png";